import { createTheme } from '@mui/material/styles'

import { componentOverrides } from '@/themes/themeOverrides'
import {
  blue,
  darkMode,
  green,
  kenneth,
  lightMode,
  semantic,
  spacing,
  SPACING_BASE_UNIT,
  typographyVariants,
} from '@/themes/tokens'

declare module '@mui/material/styles' {
  interface TypeBackground {
    dialog: string
  }
  interface Palette {
    kenneth: {
      lines: string
      accent: string
      body: string
    }
  }
  interface PaletteOptions {
    kenneth?: {
      lines: string
      accent: string
      body: string
    }
  }
  interface Theme {
    tokens: {
      spacing: typeof spacing
    }
  }
  interface ThemeOptions {
    tokens?: {
      spacing?: typeof spacing
    }
  }
}

export const getTheme = (mode: 'light' | 'dark') => {
  const colors = mode === 'light' ? lightMode : darkMode

  return createTheme({
    cssVariables: true,
    tokens: { spacing },
    palette: {
      mode,
      primary: blue,
      secondary: green,
      success: semantic.success,
      error: semantic.error,
      warning: semantic.warning,
      info: semantic.info,
      background: colors.background,
      text: colors.text,
      divider: colors.divider,
      kenneth: mode === 'light' ? kenneth.light : kenneth.dark,
    },
    typography: {
      ...typographyVariants,
      htmlFontSize: 14, // Tell MUI that 1rem = 14px (set in index.html)
    },
    spacing: SPACING_BASE_UNIT, // 8px base unit for theme.spacing() function
    components: componentOverrides,
  })
}
